<script setup lang="ts">
import { computed } from 'vue';

interface AppHighlighterProps {
  text: string;
  searchText: string;
}

const props = defineProps<AppHighlighterProps>();

const highlighted = computed(() => {
  const escapedRegex = props.searchText.replace(
    /[/\-\\^$*+?.()|[\]{}]/g,
    '\\$&'
  );

  return props.text.replace(
    new RegExp(escapedRegex, 'gi'),
    (match) => `<span class="highlighted">${match}</span>`
  );
});
</script>

<template>
  <div class="app-highlighter" v-html="highlighted" />
</template>

<style lang="scss">
@import '../../styles/_fonts.scss';
.app-highlighter {
  color: var(--color-secondary-40);
  @include font-label-l-light;

  .highlighted {
    @include font-label-l-bold;
  }
}
</style>
